import styled, { keyframes } from 'styled-components'

import Herne from '~/shared/assets/images/herne4.png'
import LoadingDots from '~/shared/components/loading/LoadingDots'

const bounceAnimation = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
`

function LoadingScreen() {
  return (
    <Wrapper>
      <LoadingImage src={Herne} alt="Loading" />
      <LoadingDots />
    </Wrapper>
  )
}

export default LoadingScreen

const Wrapper = styled.div`
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;
`

const LoadingImage = styled.img`
  /* width: 100px; */

  height: 120px;
  margin-bottom: 10px;

  /* object-fit: contain; */

  object-fit: cover;
  animation: ${bounceAnimation} 1s infinite;
`
